const Downloads = () => import('@/views/admin/Downloads');
const PlayerList = () => import('@/views/admin/PlayerList');
const Player = () => import('@/views/admin/Player');
const ACPLogs = () => import('@/views/admin/ACPLogs');
const Permissions = () => import('@/views/admin/Permissions');
const CharacterList = () => import('@/views/admin/CharacterList');
const GangList = () => import('@/views/admin/GangList');
const PropertyList = () => import('@/views/admin/PropertyList');
const Gang = () => import('@/views/admin/Gang');
const GangShop = () => import('@/views/admin/GangShop');
const CharacterInfo = () => import('@/views/admin/CharacterInfo');
const CharacterRename = () => import('@/views/admin/CharacterRename');
const CharacterDelete = () => import('@/views/admin/CharacterDelete');
const TransferMoney = () => import('@/views/admin/TransferMoney');
const Migrate = () => import('@/views/admin/Migrate');
const Messages = () => import('@/views/admin/Messages');
const Unban = () => import('@/views/admin/Unban');
const ModDashboard = () => import('@/views/admin/ModDashboard.vue');

const CharacterJobList = () => import('@/views/admin/CharacterJobList');
const AdminChatsWork = () => import('@/views/admin/AdminChatsWork');
const LangSelector = () => import('@/views/admin/LangSelector');

const routes = [
  {
    path: 'downloads',
    name: 'AdminDownloads',
    component: Downloads,
  },
  {
    path: 'players',
    name: 'AdminPlayerList',
    component: PlayerList,
  },
  {
    path: 'moddashboard',
    name: 'ModDashboard',
    component: ModDashboard,
    meta: {
      permission: 'acp.support.statistics.view',
    },
  },
  {
    path: 'acplogs',
    name: 'ACPLogs',
    component: ACPLogs,
  },
  {
    path: 'player/:id',
    name: 'AdminPlayer',
    component: Player,
  },
  {
    path: 'unban/:lang/:id',
    name: 'UnbanPlayer',
    component: Unban,
  },
  {
    path: 'permissions',
    name: 'AdminPermissions',
    component: Permissions,
  },
  {
    path: 'characters',
    name: 'AdminCharacters',
    component: LangSelector,
    meta: {
      permission: 'acp.character.rp.XX.list',
    },
    children: [
      {
        path: ':lang',
        name: 'AdminCharactersLang',
        component: CharacterList,
      },
    ],
  },
  {
    path: 'gangs',
    name: 'AdminGangs',
    component: LangSelector,
    meta: {
      permission: 'acp.gang.rp.XX.list',
    },
    children: [
      {
        path: ':lang',
        name: 'AdminGangsList',
        component: GangList,
      },
    ],
  },
  {
    path: 'properties',
    name: 'AdminProperties',
    component: LangSelector,
    meta: {
      permission: 'acp.property.rp.XX.list',
    },
    children: [
      {
        path: ':lang',
        name: 'AdminPropertiesList',
        component: PropertyList,
      },
    ],
  },
  {
    path: 'messages/',
    name: 'AdminMessages',
    component: LangSelector,
    meta: {
      permission: 'acp.messages.rp.XX.view',
    },
    children: [
      {
        path: ':lang',
        component: Messages,
      },
    ],
  },
  {
    path: 'gangs/:lang/shop',
    name: 'AdminGangShop',
    component: GangShop,
    meta: {
      permission: 'acp.rp.gang.XX.list',
    },
  },
  {
    path: 'characters/:lang/:id',
    name: 'AdminCharacterInfo',
    component: CharacterInfo,
  },
  {
    path: 'gangs/:lang/:id',
    name: 'AdminGang',
    component: Gang,
  },
  {
    path: 'tools/charrename',
    name: 'AdminCharRename',
    component: LangSelector,
    meta: {
      permission: 'acp.tools.rp.XX.charrename',
    },
    children: [
      {
        path: ':lang',
        component: CharacterRename,
      },
    ],
  },
  {
    path: 'tools/transfermoney',
    name: 'AdminTransferMoney',
    component: LangSelector,
    meta: {
      permission: 'acp.tools.rp.XX.transfermoney',
    },
    children: [
      {
        path: ':lang',
        component: TransferMoney,
      },
    ],
  },
  {
    path: 'tools/chardelete',
    name: 'AdminCharDelete',
    component: LangSelector,
    meta: {
      permission: 'acp.tools.rp.XX.chardelete',
    },
    children: [
      {
        path: ':lang',
        component: CharacterDelete,
      },
    ],
  },
  {
    path: 'tools/migrate',
    name: 'AdminMigrate',
    component: Migrate,
    meta: {
      permission: 'acp.player.migrate',
    },
  },
  {
    path: 'characterJobs',
    name: 'AdminCharacterJobList',
    component: LangSelector,
    meta: {
      permission: 'acp.jobs.rp.XX.view',
    },
    children: [
      {
        path: ':lang',
        component: CharacterJobList,
      },
    ],
  },
  {
    path: 'chats',
    name: 'AdminChats',
    component: AdminChatsWork,
  },
];

export default routes;
